import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardHeader, CardContent, Paper, Typography, Grid, Hidden } from '@material-ui/core';
import UDFDataField from '../../components/CalendarControls/UDFDataField';
import { actionAddUDFToTourEvent, actionUpdateUDF } from 'actions';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: "7px 0px 7px 25px"
    },
    hidetopheader: {
        display: 'none'
    }
}));

const BookingUDFields = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields).bookingUDFs;

    useEffect(() => {

        if (bookingUDFS && bookingUDFS.length > 0
            && bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID).length > 0) {

            if (bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID)[0].UDFCategories.length > 0) {

                bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID)[0].UDFCategories.map((bookingUdfCategory, i) => {

                    if (bookingUdfCategory.UserDefinedFields.filter(x => x.toureventID === props.toureventID).length < 1) {
                        actionAddUDFToTourEvent(dispatch, props.bookingtypeID, props.toureventID);
                    }
                });
            }
        }

    }, []);

    const onChangeHandler = (event, bookingID, categoryName, udfID) => {
        let udfValue = '';
        if (event.target.type != undefined && event.target.type == "checkbox")
            udfValue = event.target.checked;
        else
            udfValue = event.target.value;
        actionUpdateUDF(dispatch, bookingID, props.toureventID, categoryName, udfID, udfValue);
    }

    return (
        <div >

            {bookingUDFS.length > 0 && bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID).length > 0 ?
                bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID)[0].UDFCategories != null &&
                bookingUDFS.filter(x => x.BookingTypeID === props.bookingtypeID)[0].UDFCategories.map((bookingUdfCategory, i) => (
                    <Card style={{ borderRadius: "0", width: "100%" }}>
                        <CardHeader className={classes.tourheaderbox}
                            title={bookingUdfCategory.UDFCategoryName}
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent>
                            {bookingUdfCategory.UserDefinedFields.filter(x => x.toureventID === props.toureventID).map((udfs) => (
                                <>
                                    <Typography variant="h4" style={{ paddingLeft: "15px" }} >
                                        {udfs.UDFDescription} {udfs.IsRequired ? '(required)' : ''}
                                    </Typography>
                                    <UDFDataField style={{ padding: "0px 0px 0px 15px" }} key={udfs.UDFID} isMembership={false} bookingID={props.bookingtypeID} udf={udfs} changecontrolvalue={onChangeHandler} />

                                </>
                            ))}
                        </CardContent>

                    </Card>
                )) : null}

        </div>
    );
}

export default BookingUDFields;



